<template>
	<div class="advantage-section">
		<div class="header w1200 clearfix">
			<div class="header-left">
				<div class="hr"></div>
				<h2>核心优势</h2>
				<h3>SINCE 1961</h3>
			</div>
		</div>
		<div class="content1">
			<div class="content1_left">
				<h1>01<span>/BRAND</span></h1>
				<h3>品牌 – 历史悠久的美国幼儿园品牌</h3>
				<p>Kids 'R' Kids 起源于1961年，至今已经过半个多世纪的积累和沉淀，是美国最早获得权威认证AdvancED的幼儿园品牌。经过创始人夫妇长达半个世纪在幼儿教育领域的精耕细作，如今，Kids 'R' Kids 已在美国15个州拥有160余家成功运营的高品质幼儿园。2014年5月，Kids 'R' Kids在中国的幼儿园进入中国，目前已在全国多个城市地区开放近20家KRK幼儿园，已开园所受到当地家长一致好评。</p>
			</div>
			<div class="content1_right">
				<div class="diamond"></div>
				<img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/advantage/core_img1.jpg">
			</div>
		</div>
		<div class="content2">
			<div class="content2_left">
				<div class="diamond"></div>
				<img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/advantage/core_img2.jpg">
			</div>
			<div class="content2_right">
				<h1>02
					<span>/TEACHER</span>
				</h1>
				<h3>教师 – 汇聚全球优秀幼教人才</h3>
				<p>Kids 'R' Kids非常重视人才的招募和培养，并有严格的师资筛选机制。我们的一线主班老师要求为教育、心理、语言相关专业本科以上学历，中英文要达到较高水平。所有的外籍教师和中文教师必须通过 Kids 'R' Kids 的课程体系培训并获得 Kids 'R' Kids 的教学资质。 中外教双主班教学模式帮助孩子们在浸入式的语言环境中既可以发展稳定的情绪，还可以为孩子提供浸入式的英语语言环境。</p>
			</div>
		</div>
		<div class="content3">
			<div class="content3_left">
				<h1>03
					<span>/CURRICULUM</span>
				</h1>
				<h3>课程 - 与美国同步的系列课程+中文特色课程</h3>
				<p>Kids 'R' Kids在中国的幼儿园使用的课程与美国160余家Kids 'R' Kids保持一致，并同步更新。该套课程不仅填补国内0-2岁幼儿园课程的空白，还拥有一套从6星期到6岁的完整、系统的课程体系。配以大脑开发课程Brain Waves™，STEAM Ahead™跨学科课程和外部专家亲力指导的中文课程HiChina™，不仅将中国传统的24节气融入到课程当中，培养孩子中国文化底蕴，还特别研发了学科课程，有助于孩子未来学业发展。</p>
			</div>
			<div class="content3_right">
				<div class="diamond1"></div>
				<div class="diamond2"></div>
				<img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/advantage/core_img3.jpg">
			</div>
		</div>
		<div class="content4">
			<div class="content4_left">
				<div class="diamond">
					<img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/advantage/core_img5.jpg">
				</div>
				<img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/advantage/core_img4.jpg">
			</div>
			<div class="content4_right">
				<h1>04
					<span>/SAFETY</span>
				</h1>
				<h3>安全 – 全网智能体系 ，实时监控让家长安心</h3>
				<p>为保护幼儿安全，Kids 'R' Kids在中国的幼儿园配备指纹密码或人脸识别门禁系统，与在线管理系统相连，可识别有效监护人的身份；每间教室都配有监控摄像头，家长可以实时通过手机终端查看孩子在幼儿园的情况； 教室使用“全透明玻璃墙”，可有效防范意外发生。严谨的质量控制体系设有28个类别超过300项的质量标准，让家长更安心。</p>
			</div>
		</div>
		<div class="content5">
			<div class="content5_left">
				<h1>05
					<span>/EVALUATION</span>
				</h1>
				<h3>评估 – 国际评估系统，为每一个孩子定制发展建议</h3>
				<p>Kids 'R' Kids在中国的幼儿园为每位家长提供全方位的教育服务，拥有电子白板交互教学系统、电子互动课程体系、智能化幼儿园管理信息系统，以及与为孩子量身定制的TSG评估系统 。Kids 'R' Kids在中国的幼儿园幼儿评估系统与课程紧密结合，在收集了数万孩子的大数据基础上研究制定出在10大学习领域内的38项学习目标。教师依据课程来实施每天的观察和考核，将孩子的实际表现与教学目的关联，以预测他们下一步在各领域的发展方向、潜在的天赋能力以及所需的指导。</p>
			</div>
			<div class="content5_right">
				<div class="diamond1">
					<img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/advantage/core_pj.png">
				</div>
				<div class="diamond2"></div>
				<img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/advantage/core_img6.jpg">
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  components: {},
  methods: {}
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.advantage-section {
  width: 100%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  .w1200 {
    width: 1200px !important;
    margin: 0 auto;
  }
  .header {
    width: 1200px;
    height: 155px;
    overflow: hidden;
    margin-top: 110px;
    margin-bottom: 116px;
    .header-left {
      float: left;
      .hr {
        width: 96px;
        height: 4px;
        background: rgba(174, 149, 79, 1);
      }
      h2 {
        width: 375px;
        height: 96px;
        font-size: 48px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 96px;
      }
      h3 {
        width: 180px;
        height: 29px;
        line-height: 29px;
        background: rgba(174, 149, 79, 1);
        font-size: 24px;
        font-family: TimesNewRomanPS-BoldItalicMT;
        font-weight: bold;
        font-style: italic;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
  }
  .content1 {
    width: 1200px;
    height: 319px;
    margin: 0 auto;
    margin-bottom: 132px;
    .content1_left {
      width: 521px;
      height: 319px;
      margin-right: 122px;
      float: left;
      h1 {
        height: auto;
        font-size: 72px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 15px;
        span {
          width: 127px;
          height: 28px;
          margin-left: 29px;
          font-size: 30px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 44px;
        }
      }
      h3 {
        width: auto;
        height: 23px;
        font-size: 24px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 65px;
      }
      p {
        width: 521px;
        height: 145px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
    }
    .content1_right {
      width: 556px;
      height: 319px;
      float: left;
      .diamond {
        position: relative;
        top: 292px;
        left: 478px;
        width: 80px;
        height: 80px;
        background: rgba(0, 52, 120, 1);
        overflow: hidden;
      }
      img {
        position: relative;
        left: 0px;
        top: -56px;
        float: left;
        width: 520px;
        height: 319px;
      }
    }
  }
  .content2 {
    width: 1200px;
    height: 382px;
    margin: 0 auto;
    margin-bottom: 128px;
    .content2_left {
      width: 532px;
      height: 382px;
      float: left;
      margin-right: 72px;
      .diamond {
        position: relative;
        top: 78px;
        left: 0px;
        width: 90px;
        height: 90px;
        background: rgba(174, 149, 79, 1);
        overflow: hidden;
      }
      img {
        position: relative;
        left: 12px;
        top: 0px;
        float: left;
        width: 520px;
        height: 300px;
      }
    }
    .content2_right {
      width: 542px;
      height: 382px;
      float: left;
      h1 {
        height: auto;
        font-size: 72px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 20px;
        span {
          width: 127px;
          height: 28px;
          margin-left: 29px;
          font-size: 30px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 44px;
        }
      }
      h3 {
        width: auto;
        height: 23px;
        font-size: 24px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 65px;
      }
      p {
        width: 542px;
        height: 176px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
    }
  }
  .content3 {
    width: 1200px;
    height: 319px;
    margin: 0 auto;
    margin-bottom: 201px;
    .content3_left {
      width: 521px;
      height: 319px;
      margin-right: 122px;
      float: left;
      h1 {
        height: auto;
        font-size: 72px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 20px;
        span {
          width: 127px;
          height: 28px;
          margin-left: 29px;
          font-size: 30px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 44px;
        }
      }
      h3 {
        width: auto;
        height: 23px;
        font-size: 24px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 65px;
      }
      p {
        width: 556px;
        height: 177px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
    }
    .content3_right {
      width: 556px;
      height: 319px;
      float: left;
      .diamond1 {
        position: relative;
        top: 77px;
        left: -13px;
        width: 90px;
        height: 90px;
        background: rgba(174, 149, 79, 1);
        overflow: hidden;
      }
      .diamond2 {
        position: relative;
        top: 276px;
        left: 484px;
        width: 80px;
        height: 80px;
        background: rgba(0, 52, 120, 1);
        overflow: hidden;
      }
      img {
        position: relative;
        left: 0px;
        top: -80px;
        float: left;
        width: 520px;
        height: 319px;
      }
    }
  }
  .content4 {
    width: 1200px;
    height: 382px;
    margin: 0 auto;
    margin-bottom: 240px;
    .content4_left {
      width: 532px;
      height: 382px;
      float: left;
      margin-right: 44px;
      position: relative;
      .diamond {
        position: absolute;
        top: 330px;
        left: 407px;
        width: 300px;
        height: 190px;
        img {
          width: 300px;
          height: 190px;
          float: left;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 2;
        }
      }
      img {
        position: relative;
        left: 12px;
        top: 100px;
        float: left;
        width: 520px;
        height: 300px;
      }
    }
    .content4_right {
      width: 542px;
      height: 382px;
      float: left;
      h1 {
        height: auto;
        font-size: 72px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 20px;
        span {
          width: 127px;
          height: 28px;
          margin-left: 29px;
          font-size: 30px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 44px;
        }
      }
      h3 {
        width: auto;
        height: 23px;
        font-size: 24px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 60px;
      }
      p {
        width: 525px;
        height: 113px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
      }
    }
  }
  .content5 {
    width: 1200px;
    height: 319px;
    margin: 0 auto;
    margin-bottom: 199px;
    .content5_left {
      width: 521px;
      height: 319px;
      margin-right: 122px;
      float: left;
      h1 {
        height: auto;
        font-size: 72px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 20px;
        span {
          width: 127px;
          height: 28px;
          margin-left: 29px;
          font-size: 30px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 44px;
        }
      }
      h3 {
        width: 540px;
        height: 23px;
        font-size: 24px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 44px;
        margin-bottom: 65px;
      }
      p {
        width: 581px;
        height: 177px;
        font-size: 16px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32px;
        a {
          color: #094ca4;
          text-decoration: underline;
        }
      }
    }
    .content5_right {
      width: 556px;
      height: 319px;
      float: left;
      position: relative;
      .diamond1 {
        position: absolute;
        top: -87px;
        left: 280px;
        width: 199px;
        height: 131px;
        img {
          width: 199px;
          height: 131px;
          float: left;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .diamond2 {
        position: relative;
        top: 356px;
        left: 484px;
        width: 80px;
        height: 80px;
        background: rgba(0, 52, 120, 1);
        overflow: hidden;
      }
      img {
        position: relative;
        left: 0px;
        top: 0px;
        float: left;
        width: 520px;
        height: 319px;
      }
    }
  }
}
@media (max-width: 767px) {
  .advantage-section {
    .w1200 {
      width: 100% !important;
      margin: 0 auto;
    }
    .header {
      width: 100;
      height: 68px;
      overflow: hidden;
      margin-top: 35px;
      margin-bottom: 35px;
      .header-left {
        width: 100%;
          box-sizing: border-box;
          padding-left: 7.7%;
        .hr {
          width: 56px;
            height: 3px;
        }
        h2 {
          width: 100%;
            height: 41px;
            font-size: 21px;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            font-family: PingFangSC-Medium;
            padding: 10px 0 8px;
            box-sizing: border-box;
        }
        h3 {
          width: 64px;
            height: 20px;
            font-size: 10px;
            font-family: TimesNewRomanPS-BoldItalicMT;
            font-weight: normal;
            line-height: 20px;
            background: rgba(174, 149, 79, 1);
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            padding: 0 5px;
        }
      }
    }
    .content1 {
      width: 100%;
      height: 468px;
      margin-bottom: 53px;
	  display: flex;
	  padding: 0 7.6%;
	  box-sizing: border-box;
	  flex-direction: column-reverse;
      .content1_left {
        width: 100%;
        height: 319px;
        margin-right: 0;
        h1 {
          height: auto;
		  margin-top: 20px;		  
          font-size: 31px;
          line-height: 32px;
          margin-bottom: 6px;
          span {
            width: 127px;
            height: 28px;
            margin-left: 6px;
            font-size: 14px;
            line-height: 32px;
          }
        }
        h3 {
          width: auto;
          height: 26px;
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 23px;
        }
        p {
          width: 100%;
          height: 145px;
          font-size: 13px;
          line-height: 21px;
        }
      }
      .content1_right {
        width: 100%;
        height: auto;
        .diamond {
          display: none;
        }
        img {
		  top: 0;
          width: 100%;
          height: auto;
        }
      }
    }
    .content2 {
      width: 100%;
      height: 468px;
      margin-bottom: 53px;
	  padding: 0 7.6%;
	  box-sizing: border-box;
      .content2_left {
        width: 100%;
        height: auto;
		margin-right: 0;
        .diamond {
          display: none;
        }
        img {
          top: 0;
		  left: 0;
          width: 100%;
          height: auto;
        }
      }
      .content2_right {
        width: 100%;
        height: 319px;
        h1 {
          height: auto;
		  margin-top: 20px;		  
          font-size: 31px;
          line-height: 32px;
          margin-bottom: 6px;
          span {
            width: 127px;
            height: 28px;
            margin-left: 6px;
            font-size: 14px;
            line-height: 32px;
          }
        }
        h3 {
          width: auto;
          height: 26px;
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 23px;
        }
        p {
          width: 100%;
          height: 168px;
          font-size: 13px;
          line-height: 21px;
        }
      }
    }
    .content3 {
      width: 100%;
      height: 468px;
      margin-bottom: 53px;
	  display: flex;
	  padding: 0 7.6%;
	  box-sizing: border-box;
	  flex-direction: column-reverse;
      .content3_left {
        width: 100%;
        height: 319px;
        margin-right: 0;
        h1 {
          height: auto;
		  margin-top: 20px;		  
          font-size: 31px;
          line-height: 32px;
          margin-bottom: 6px;
          span {
            width: 127px;
            height: 28px;
            margin-left: 6px;
            font-size: 14px;
            line-height: 32px;
          }
        }
        h3 {
          width: auto;
          height: 26px;
          font-size: 15px;
          line-height: 26px;
          margin-bottom: 15px;
        }
        p {
          width: 100%;
          height: 145px;
          font-size: 13px;
          line-height: 21px;
        }
      }
      .content3_right {
        width: 100%;
        height: auto;
        .diamond1 {
           display: none;
        }
        .diamond2 {
           display: none;
        }
        img {
          top: 0;
          width: 100%;
          height: auto;
        }
      }
    }
    .content4 {
      width: 100%;
      height: 468px;
      margin-bottom: 53px;
	  padding: 0 7.6%;
	  box-sizing: border-box;
      .content4_left {
        width: 100%;
        height: auto;
		margin-right: 0;
        .diamond {
          display: none;
        }
        img {
          top: 0;
		  left: 0;
          width: 100%;
          height: auto;
        }
      }
      .content4_right {
        width: 100%;
        height: 319px;
        h1 {
          height: auto;
		  margin-top: 20px;		  
          font-size: 31px;
          line-height: 32px;
          margin-bottom: 6px;
          span {
            width: 127px;
            height: 28px;
            margin-left: 6px;
            font-size: 14px;
            line-height: 32px;
          }
        }
        h3 {
          width: auto;
          height: 26px;
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 15px;
        }
        p {
          width: 100%;
          height: 168px;
          font-size: 13px;
          line-height: 21px;
        }
      }
    }
    .content5 {
      width: 100%;
      height: 468px;
      margin-bottom: 53px;
	  display: flex;
	  padding: 0 7.6%;
	  box-sizing: border-box;
	  flex-direction: column-reverse;
      .content5_left {
        width: 100%;
        height: 319px;
        margin-right: 0;
        h1 {
          height: auto;
		  margin-top: 20px;		  
          font-size: 31px;
          line-height: 32px;
          margin-bottom: 6px;
          span {
            width: 127px;
            height: 28px;
            margin-left: 6px;
            font-size: 14px;
            line-height: 32px;
          }
        }
        h3 {
          width: auto;
          height: 26px;
          font-size: 14px;
          line-height: 26px;
          margin-bottom: 15px;
        }
        p {
          width: 100%;
          height: 145px;
          font-size: 13px;
          line-height: 21px;
        }
      }
      .content5_right {
        width: 100%;
        height: auto;
        .diamond1 {
          display: none;
        }
        .diamond2 {
          display: none;
        }
        img {
          top: 0;
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/choose/advantage.vue